import React from 'react';
import { FoundationTeam } from '../components/FoundationTeam';
import { Intro } from 'structure/home/components/Intro';
import { StackedCard } from 'structure/home/components/StackedCard';
import { MigrationGuide } from 'structure/home/components/MigrationGuide';
// import { SupportedBy } from 'structure/home/components/SupportedBy';
import { GridCards } from 'structure/home/components/GridCards';
import { DappWorld } from '../components/DappWorld';

export function HomePage() {
  return (
    <main className='m-0 flex flex-col gap-[6.25rem] p-0 pb-[220px] lg:gap-[10rem]'>
      <Intro />
      <div className='m-0 flex flex-col gap-[6.25rem] p-0 lg:gap-[10rem]'>
        <StackedCard anchorId={'vision'} />
        <DappWorld anchorId={'ai_value_chain'} />
        <GridCards anchorId={'features'} />
        <MigrationGuide anchorId={'merger_details'} />
        {/*<SupportedBy />*/}
        <FoundationTeam anchorId={'people'} />
      </div>
    </main>
  );
}
